<template>
  <div>
    <main class="main-content">
      <div class="card">
        <div class="card-body">
          <div class="d-flex justify-content-between align-items-center">
            <h6 class="card-title">نمایش مقام ها</h6>
            <router-link type="button" class="btn btn-outline-success" v-if="can('roles.create')" :to="{name: 'roles.create'}">ایجاد مقام</router-link>
          </div>
          <div class="d-flex justify-content-center height" v-if="data==null">
            <div class="spinner-border text-primary" role="status">
              <span class="sr-only">در حال بارگذاری ...</span>
            </div>
          </div>
          <div class="table-responsive" v-else>
            <table class="table table-striped table-bordered">
              <thead>
                <tr>
                  <th>ردیف</th>
                  <th>نام</th>
                  <th>توضیح</th>
                  <th v-if="can('roles.edit') && can('roles.destroy')">تنظیمات</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(role , index) in data" :key="index">
                  <td>{{index+1}}</td>
                  <td v-text="role.name"></td>
                  <td v-text="role.label"></td>
                  <td v-if="can('roles.edit') && can('roles.destroy')">
                    <div class="btn-group" role="group" aria-label="Basic example">
                     <button type="button" class="btn btn-outline-warning btn-rounded btn-uppercase" v-if="can('roles.edit')">
                        <router-link
                          :to="{
                          name:'roles.edit',
                          params: { id: role.id}
                          }">
                          <em class="fa fa-edit m-r-5"></em> ویرایش
                        </router-link>
                      </button>
                      <button type="button" class="btn btn-outline-danger btn-rounded btn-uppercase" v-if="can('roles.destroy')">
                        <em class="ti-trash"></em> حذف
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <th>ردیف</th>
                  <th>نام</th>
                  <th>توضیح</th>
                  <th v-if="can('roles.edit') && can('roles.destroy')">تنظیمات</th>
                </tr>
              </tfoot>
            </table>
            <paginations :count="pagination.count" :current="pagination.currentPage" v-on:pages="page"></paginations>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import pagination from '@/mixins/pagination.js'
import paginations from '@/components/partials/paginations.vue'
export default {
  name: 'RoleIndex',
  mixins: [pagination],
  components: {
    paginations
  },
  data () {
    return {
      data: null,
      url: '/api/roles'
    }
  }
}
</script>
